class HotJobsFilter {
    constructor() {
        this.$filterComponent = $('#cp-custom-filter-simple')

        if (this.$filterComponent.length <= 0) {
            console.error(`#cp-custom-filter-simple does not exist`)
            return
        }

        this.$openBtn = $('#cp-custom-filter-simple-open-btn')
        this.$dropdown = $('#cp-custom-filter-simple-open-dropdown')
        this.init()
    }

    // Private Methods
    _closeDropdown() {
        this.$dropdown.removeClass('show')
        this.$openBtn.attr('aria-expanded','false')
    }

    _fetchJobs(country) {
        $.ajax({
            url: window.location.pathname,
            type: 'GET',
            data: {
                country: country
            },
            success: function(res) {
                $('.hot-jobs .columns').html(res)
            }
        })
    }

    _openDropdown() {
        this.$dropdown.addClass('show')
        this.$openBtn.attr('aria-expanded','true')
    }

    _startLoading() {
        $('.hot-jobs .loading').addClass('show')
    }

    _updateButtonText(country) {
        this.$openBtn.text(country)
    }

    _onClick(e) {
        const country = $(e.currentTarget).data('country')

        if (!country) {
            return
        }

        this._closeDropdown()
        this._startLoading()
        this._updateButtonText(country)
        this._fetchJobs(country)
    }

    setupEvents() {
        this.$openBtn.on('click', e => {
            e.stopPropagation()
            this._openDropdown()
        })

        // On Options Click
        const $option = this.$filterComponent.find('li')

        $option.on('click', e => {
            this._onClick(e)
        })

        $option.on('keypress', e => {
            if (event.which != 13) {
                return
            }

            this._onClick(e)
        })

        // On Window Click
        $(window).on('click', e => {
            this._closeDropdown()
        })
    }

    init() {
        this.setupEvents()
    }
}

export default HotJobsFilter;
